import BrandNamesImg from "../assets/desktop/image-slide-1.jpg";
import BrandIdentityImg from "../assets/desktop/image-slide-2.jpg";
import WebIdentityImg from "../assets/desktop/image-slide-3.jpg";

export const images =[
    {title: "Brand naming & guidelines", img: BrandNamesImg, imgtitle: "Lean Product Roadmap", date: " 2019 Project"},
    {title: "Brand identity & merchandise", img: BrandIdentityImg, imgtitle: "New Majestic Hotel", date: " 2018 Project"},
    {title: "Brand identity & web design", img: WebIdentityImg, imgtitle: "Crypto Dashboard", date: " 2015 Project"}
];